/**
 * Normaliza un campo de precio/porcentaje del backend (`sale_price`, `discount`)
 * a `number | null`. El mismo campo llega como cadena en `/search` (`"10"`,
 * `"51,0"`, `"80"`) y como número en PDP/`/postsales` (`80`); admite coma o punto
 * decimal y un `%` final. Vacío, `null`, `undefined`, negativo o no parseable ⇒
 * `null` (FR-018/FR-019: se aplica el cálculo habitual).
 */
export function parsePriceField(value: string | number | null | undefined): number | null {
  if (value == null) return null
  const text = typeof value === 'number' ? String(value) : value.trim().replace(/%$/, '').replace(',', '.')
  if (text === '') return null
  const numeric = Number(text)
  return Number.isFinite(numeric) && numeric >= 0 ? numeric : null
}
